import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { Link } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


export default function AssignRole() {

    const navigate = useNavigate();

    const isAuth = useAuth();
    if (isAuth === false) {
        navigate("/admin/")
    }

    let totalrole = 0;
    let totalperm = 0;

    const [userpermissions, setUserPermissionData] = useState([]);
    const [userroles, setUserRolesData] = useState([]);
    const [roles, setRolesData] = useState([]);
    const [permission, setPermissionData] = useState([]);
    const [istost, settost] = useState(false);
    const tableRef = useRef(null);


    const [isviewrole, setViewRole] = useState(false);//13/3/2024
    const [isviewperm, setViewPerm] = useState(false);//13/3/2024
    const [isassignperm, setAssignPerm] = useState(false);//13/3/2024
    const [isassignrole, setAssignRole] = useState(false);//13/3/2024
    const [showRoleSelect, setShowRoleSelect] = useState(false);//14/3/2024
    const [selectedRole, setSelectedRole] = useState(null); // State to hold selected role
    const [message, setMessage] = useState(false);
    const [showPermSelect, setShowPermSelect] = useState(false);//14/3/2024
    const [selectedPerm, setSelectedPerm] = useState(null); // State to hold selected role
    const [username, setUsername] = useState("");




    let { id } = useParams();
    const decodedID = atob(id);
    const { http } = Api();

    //role validation -13/3/2024
    useEffect(() => {
        const access = async () => {

            const id = localStorage.getItem("id");
            try {
                const response = await http.get('/Admin/get-all-user-permissions', { params: { user_id: id } });

                const permissions = response.data;
                permissions.forEach(permission => {

                    if (permission.name === "get-user-roles") {
                        setViewRole(true);
                    }


                    if (permission.name === "get-user-additional-permissions") {
                        setViewPerm(true);
                    }

                    if (permission.name === "assign-role") {
                        setAssignRole(true);
                    }

                    if (permission.name === "assign-permission") {
                        setAssignPerm(true);
                    }
                });
            } catch (error) {
                setViewRole(false);
                setViewPerm(false);
                setAssignRole(false);
                setAssignPerm(false);
            }
        };
        access();
    }, []);





    useEffect(() => {
        settost(sessionStorage.getItem("message"));
        fetchData();
        fetchRoleData();
    }, []);

    const fetchData = async () => {
        try {

            const { http } = Api();
            const response = await http.get(`/Admin/get-user-additional-permissions`, {
                params: {
                    "user_id": decodedID
                }
            });


            setUserPermissionData(response.data);





        } catch (error) {
            console.error('Error fetching user log data:', error);


        }
    };

    const fetchRoleData = async () => {
        try {

            const { http } = Api();
            const response = await http.get(`/Admin/get-user-roles`, {
                params: {
                    "user_id": decodedID
                }
            });
            setUserRolesData(response.data);



        } catch (error) {
            console.error('Error fetching user log data:', error);

        }
    };




    useEffect(() => {
        if (istost) {
            toast.success(istost);
            sessionStorage.removeItem("message");
            settost(false);
        }
    }, [istost]);


    useEffect(() => {


        const fetchFullROlles = async () => {
            try {

                const { http } = Api();
                const response = await http.get(`/Admin/get-roles`, {
                    params: {
                        limit: '1000',
                    }
                });
                setRolesData(response.data.data);


            } catch (error) {
                console.error('Error fetching data:', error);

            }


        };
        fetchFullROlles();
    }, []);


    useEffect(() => {


        const fetchFullPerm = async () => {
            try {

                const { http } = Api();
                const response = await http.get(`/Admin/get-permissions`, {
                    params: {
                        limit: '1000',
                    }
                });
                setPermissionData(response.data.data);


            } catch (error) {
                console.error('Error fetching data:', error);

            }


        };
        fetchFullPerm();
    }, []);

    const encodeID = id => {
        return btoa(id);
    };

    const saveRole = (event) => {
        event.preventDefault();
        const endpoint1 = `/Admin/${decodedID}/assign-role/${selectedRole}`;


        http.put(endpoint1)
            .then(response => {



                if (response.data.status_code === 'MSG9') {

                    sessionStorage.setItem("message", "Role assigned successfully");
                    //navigate(`/assignroles/${encodeID(decodedID)}`);
                    window.location.reload();



                }
            })
            .catch(error => {
                console.error(error);
                setShowRoleSelect(false);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    const errorMessage = error.response.data.message; // Extract error message from response
                    toast.error(errorMessage);
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
            });

    };

    const savePerm = (event) => {
        event.preventDefault();
        const endpoint1 = `/Admin/${decodedID}/give-permission/${selectedPerm}`;


        http.put(endpoint1)
            .then(response => {

                if (response.data.status_code === 'MSG10') {

                    sessionStorage.setItem("message", "Permission assigned successfully");
                    //navigate(`/assignroles/${encodeID(decodedID)}`);
                    window.location.reload();
                }

            })
            .catch(error => {
                console.error(error);
                setShowPermSelect(false);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    const errorMessage = error.response.data.message; // Extract error message from response
                    toast.error(errorMessage);
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
            });

    };
    //20/3/2024
    useEffect(() => {
        const access = async () => {
            const { http } = Api();
            const id1 = decodedID;
            try {
                const response = await http.get(`/getuserlistbyID/${id1}`);
                setUsername(response.data.name)
                console.log("Response Data:", response.data.name);

            } catch (error) {
                console.error("Error fetching user roles:", error);

            }
        };
        access();
    }, []);

    
    return (
        <>
            <ToastContainer />
            <Template>

                <div className="container-fluid">
                    <div className="row">
                       
                            {/*message && (
                      <div className="alert alert-danger mar2" role="alert">
                        <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                      </div>
                        )*/}
                      

                        <div className="col-md-6 mb1">
                            <div className="card h-100">
                                <div className="card-header">
                                    <div className="py-3 d-flex justify-content-between align-items-center ">
                                        <h5>{username} Roles</h5>
                                        <div className="d-flex ml-auto">

                                            {isassignrole && (
                                                <>
                                                    <button
                                                        className="btn btn1 btn-ml btn-primary form-group"
                                                        onClick={() => setShowRoleSelect(!showRoleSelect)}
                                                    >
                                                        Add
                                                    </button>



                                                </>
                                            )}

                                        </div>
                                    </div>
                                    {showRoleSelect && (
                                        <div className="border p-3 mt-3">
                                            <form className="form theme-form">
                                                <div className="row custom-input">
                                                    <div className="col">
                                                        <div className="mb-3 row">

                                                            <div className="col-sm-12">
                                                                <select className="form-control scrollable-bar-select " id="rolename"
                                                                    onChange={(e) => setSelectedRole(e.target.value)} name="rolename" required style={{ fontSize: '14px' }}>
                                                                    <option value={0} >Select Roles</option>

                                                                    {roles.map(roles => (

                                                                        <option value={roles.name}  >{roles.name}</option>
                                                                    ))}

                                                                </select>


                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12" style={{ textAlign: 'right' }}>
                                                        <button className="btn btn-secondary me-3" type="submit" onClick={saveRole} >Submit</button>

                                                    </div>
                                                </div>

                                            </form></div>

                                    )}


                                </div>

                                <div className="card-body d-flex justify-content-center">
                                    <div className="col-sm-12">




                                        <div className="table-responsive">
                                            {isviewrole && (
                                                <table className="display dataTable table-striped table-bordered" id="dataTable" ref={tableRef}>
                                                    <thead>
                                                        <tr className="bg-primary">

                                                            <th >Role name &nbsp;
                                                            </th>




                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {userroles.map(roles => {


                                                            return (
                                                                <tr key={roles.role_name}>

                                                                    <td>{roles.role_name}</td>

                                                                </tr>
                                                            );

                                                        })}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className=" col-md-6" >
                            <div className="card h-100">
                                <div className="card-header">
                                    <div className="py-3 d-flex justify-content-between align-items-center ">
                                        <h5>{username} Permissions</h5>
                                        <div className="d-flex ml-auto">

                                            {isassignperm && (
                                                <Link className="btn btn1 btn-m1 btn-primary form-group" onClick={() => setShowPermSelect(!showPermSelect)}>Add</Link>
                                            )}
                                        </div>
                                    </div>

                                    {showPermSelect && (
                                        <div className="border p-3 mt-3">
                                            <form className="form theme-form">
                                                <div className="row custom-input">
                                                    <div className="col">
                                                        <div className="mb-3 row">

                                                            <div className="col-sm-12">
                                                                <select className="form-control scrollable-bar-select " id="permname"
                                                                    onChange={(e) => setSelectedPerm(e.target.value)} name="permname" required style={{ fontSize: '14px' }}>
                                                                    <option value={0} >Select Permission</option>

                                                                    {permission.map(permission => (

                                                                        <option value={permission.name}  >{permission.name}</option>
                                                                    ))}

                                                                </select>


                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12" style={{ textAlign: 'right' }}>
                                                        <button className="btn btn-secondary me-3" type="submit" onClick={savePerm} >Submit</button>

                                                    </div>
                                                </div>

                                            </form></div>

                                    )}
                                </div>

                                <div className="card-body pdg1 d-flex justify-content-center">



                                    <div className="col-sm-12">
                                        <div className="table-responsive">
                                            {isviewperm && (
                                                <table className="display dataTable table-striped table-bordered" id="dataTable1" ref={tableRef}>
                                                    <thead>
                                                        <tr className="bg-primary">

                                                            <th >
                                                                Permission name
                                                            </th>




                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {userpermissions.map((permission, index) => (
                                                            <tr key={index}>

                                                                <td>{permission}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
               
            </Template>
        </>
    );
}
